import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DialogSegmentsComponent } from './dialogs/dialog-segments.component';
import { FiltersComponent } from './filters/filters.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { SegmentService } from './services/segment.service';
var SegmentComponent = /** @class */ (function () {
    function SegmentComponent(fuseTranslationLoaderService, authenticationService, progressBarService, sidebarService, segmentService, matDialog) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.authenticationService = authenticationService;
        this.progressBarService = progressBarService;
        this.sidebarService = sidebarService;
        this.segmentService = segmentService;
        this.matDialog = matDialog;
        this.segmentDetailSidebarName = 'segmentDetail';
        this.displayedColumns = ['name', 'createdAt', 'edit'];
        this.segments = [];
        this.filtered = false;
        this.loading = true;
        this.subscriptions = new Subject();
        this.segmentsReload = new Subject();
        this.hasEditSegmentPermission = this.authenticationService.hasPermission('segments-edit');
        this.hasCreateSegmentPermission = this.authenticationService.hasPermission('segments-create');
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    SegmentComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.loading = true;
                this.sort.active = 'name';
                this.sort.direction = 'asc';
                merge(this.sort.sortChange, this.paginator.page, this.filterSegmentsComponent.filterChanged.pipe(tap(function () { return _this.paginator.firstPage(); })), this.segmentsReload)
                    .pipe(debounceTime(500), takeUntil(this.subscriptions), switchMap(function () {
                    _this.sort.direction = _this.sort.direction || 'asc';
                    var options = {
                        orderBy: _this.sort.active + "_" + _this.sort.direction,
                        offset: _this.paginator.pageIndex * _this.paginator.pageSize,
                        limit: _this.paginator.pageSize
                    };
                    _this.loading = true;
                    return _this.segmentService.loadData({ where: _this.filterSegmentsComponent.filterChanged.value, options: options });
                }))
                    .pipe(takeUntil(this.subscriptions))
                    .subscribe(function (result) {
                    _this.datatable.nativeElement.scrollTo({
                        top: 0,
                    });
                    _this.segments = result.items;
                    _this.totalCount = result.totalCount;
                    _this.filtered = result.filtered;
                    _this.loading = false;
                });
                return [2 /*return*/];
            });
        });
    };
    SegmentComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    SegmentComponent.prototype.reload = function () {
        this.segmentsReload.next();
    };
    SegmentComponent.prototype.toggleFilterSegmentsSidebar = function () {
        this.sidebarService.getSidebar('filterSegments').toggleOpen();
    };
    SegmentComponent.prototype.openDialog = function (segmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var segment, segmentDialog;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.progressBarService.show();
                        segment = null;
                        if (!segmentId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.segmentService.getSegmentById(segmentId)];
                    case 1:
                        segment = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        segment = {
                            archived: false,
                            name: null,
                            segmentMaintenanceTypeForms: []
                        };
                        _a.label = 3;
                    case 3:
                        segmentDialog = this.matDialog.open(DialogSegmentsComponent, {
                            panelClass: ['dialog-segments'],
                            data: {
                                segment: segment,
                                isViewMode: segmentId && !this.hasEditSegmentPermission
                            }
                        });
                        segmentDialog.afterClosed().subscribe(function (reload) {
                            if (reload) {
                                _this.reload();
                            }
                        });
                        this.progressBarService.hide();
                        return [2 /*return*/];
                }
            });
        });
    };
    SegmentComponent.prototype.clearFilters = function () {
        this.filtered = false;
        this.filterSegmentsComponent.clearFilters();
    };
    return SegmentComponent;
}());
export { SegmentComponent };
